import type { SVGProps } from 'react';

interface ChevronCaretIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

const CARET_PATH =
  'M8.5271 4.40185e-07L16.7448 7.90167C17.1672 8.30783 17.1556 8.98729 16.7194 9.37867C16.3284 9.7296 15.7334 9.72136 15.3522 9.35974L8.5271 2.88462L1.70197 9.35974C1.3208 9.72136 0.7258 9.7296 0.334763 9.37867C-0.101352 8.98729 -0.113038 8.30783 0.309358 7.90167L8.5271 4.40185e-07Z';

const CARET_PATHS = (
  <>
    <path d={CARET_PATH} fill="currentColor" />
    <path d={CARET_PATH} fill="black" fillOpacity="0.2" />
  </>
);

export function ChevronCaretIcon({ className, ...props }: ChevronCaretIconProps) {
  return (
    <svg
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {CARET_PATHS}
    </svg>
  );
}
